import React, { useEffect, useRef } from 'react';
interface ChatContainerProps {
  children: React.ReactNode;
}
export function ChatContainer({
  children
}: ChatContainerProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const bottomRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    // Scroll hanya di dalam container, bukan halaman utama
    if (containerRef.current && bottomRef.current) {
      const container = containerRef.current;
      // Gunakan scrollTop untuk scroll internal container saja
      container.scrollTop = container.scrollHeight;
    }
  }, [children]);
  return <div className="flex flex-col h-[600px] max-h-[75vh] bg-slate-50 rounded-xl border border-slate-200 overflow-hidden shadow-inner" data-id="element-65">
      <div ref={containerRef} className="flex-1 overflow-y-auto p-4 sm:p-6 space-y-2" data-id="element-66">
        {children}
        <div ref={bottomRef} data-id="element-67" />
      </div>
    </div>;
}